import { Entity, Field } from "typegraph";

import { IAbstractEntity } from "../fields/entitySelect/IEntitySelect";
import { TagSet } from "./TagSet";

@Entity({one: "tag", many: "tags"})
export default class Tag implements IAbstractEntity {

	@Field()
	public id: string | number;

	@Field()
	public name: string;

	@Field({entity: TagSet})
	public tagSet: TagSet;

}



// WEBPACK FOOTER //
// ./src/common/form/entities/Tag.ts